<template>
  <div class="special-wrap">
    <div class="flex-y-center flex-between">
      <el-button type="primary" round @click="toLink($router,'/course/specialadd',true)">新建专题</el-button>
      <div class="search-wrap">
        <div class="search-item">
          <el-select v-model="status"  placeholder="请选择状态" @change="statusChange">
            <el-option
              v-for="item in options.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item">
        </div>
        <div class="iblock search-item">
          <el-input placeholder="搜索专栏" v-model="specialName">
            <el-button slot="append" icon="el-icon-search" @click="seachKeywords()"></el-button>
          </el-input>
        </div>
      </div>
    </div>

    <div class="special-list-wrap" v-loading="tableLoading">
      <h3 class="little-title">专题列表（{{specialList.count}}）</h3>
      <el-table class="special-table" :data="specialList.list" stripe 
      :header-cell-style="{backgroundColor:'#f5f7fa'}"
      style="width:100%">
        <el-table-column prop="topic_name" label="专题名称"></el-table-column>
        <el-table-column prop="course_count" label="更新期数"></el-table-column>
        <el-table-column prop="subscribe_num" label="订阅量"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==-1">删除</span>
            <span v-show="scope.row.state==1">定时上架</span>
            <span v-show="scope.row.state==2">已上架</span>
            <span v-show="scope.row.state==3">下架/未上架</span>
          </template>
        </el-table-column>
        <el-table-column prop="published_at" label="上架时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="toLink($router,`/course/specialmanage/${scope.row.topic_id}`,true)"
            >内容管理</el-button>
            <el-button v-if="scope.row.state==2||scope.row.state==1" type="text" size="mini" @click="downline(topicOffline(),{topic_id:scope.row.topic_id},getTopicList)">下架</el-button>
            <el-button v-if="scope.row.state==3" type="text" size="mini" @click="online(topicOnline(),{topic_id:scope.row.topic_id},getTopicList)">上架</el-button>
            <el-button type="text" size="small" @click="openShare(scope.row.topic_id,2)">分享</el-button>
            <el-dropdown class="dropdown-btn">
              <el-button type="text" size="small">
                更多
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="toLink($router,`/course/specialedit/${scope.row.topic_id}`,true)"
                  >编辑</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button type="text" size="small" @click="delItem(topicDel(),{topic_id:scope.row.topic_id},getTopicList)">删除</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(specialList.count)"
        ></el-pagination>
      </div>
    </div>
      <!-- 分享弹窗 -->
    <share-dialog :shareVisible.sync="shareVisible" :share_info="share_info"></share-dialog>
  </div>
</template>

<script>
import util from "@/base/js/util";
import course_mixins from "../play-template/course-mixins";

import { 
_topicSingleinfo,//获取单条专辑的信息
_topicOnline,//专题上架
_topicOffline,//专题下架
_topicDel,// 专题删除
_topicAdd,//专题创建
_getTopicList,//专题列表
_topicEdit//专题编辑
} from "@/api/topic";

export default {
  mixins: [course_mixins],
  data() {
    return {
      tableLoading:true,//loading
      status: "0",
      courseSeries: "",
      specialName: "",
      specialList: [
      ],
      options: {
        status: [
        {
          label: "全部状态",
          value: "0"
        },
         {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
        ],
        courseSeries: [
          {
            label: "全部系列课",
            value: ""
          },
          {
            label: "AI",
            value: "1"
          },
          {
            label: "自动驾驶",
            value: "2"
          },
          {
            label: "的撒旦撒旦撒",
            value: "3"
          }
        ]
      },
      // 翻页信息
      search:{
      page:1,
      size:10
      }
    };
  },
  created() {
    this.getTopicList();
  },
  methods: {
    statusChange(val) {
      this.chearSearchState();
      this.getTopicList();      
    },
    seachKeywords(){
      this.chearSearchState();
      this.getTopicList();      
    },
    //加载列表
    getTopicList() {
      _getTopicList({
        params: {
          page:this.search.page,
          size:this.search.size,
          keywords:this.specialName,
          state:this.status
        }
      }).then(res => {
        // console.log(res);
        this.tableLoading=false;
        if (res.resultCode == 1) {
          //添加一个单选功能属性来控制
          this.specialList=res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
     //翻页
    handleCurrentChange(val) {
      // console.log(val);
      this.search.page = val
      this.getTopicList()
    },
    // 上架
    topicOnline(){
     return _topicOnline
    },
    //下架
    topicOffline(){
      return _topicOffline
    },
    //删除
    topicDel(){
      return _topicDel
    },
  },
  components: {}
};
</script>

<style lang="less" scoped>
.search-item {
  display: inline-block;
  & + .search-item {
    margin-left: 10px;
  }
}

.special-list-wrap {
  margin-top: 20px;
}

.special-table {
  margin-top: 10px;
}

.dropdown-btn {
  margin-left: 10px;
}

.pagination-wrap {
  margin-top: 20px;
  text-align: center;
}
</style>
